// extracted by mini-css-extract-plugin
module.exports = {"ssgxm6n":"ssgxm6n","disabled":"disabled","selected":"selected"};